module.exports = __webpack_public_path__ + "static/media/modifier.388b3131.png";